goog.provide("shadow.js.shim.module$react_masonry_component");
goog.provide("module$shadow_js_shim_module$react_masonry_component");
shadow.js.shim.module$react_masonry_component = shadow.js.nativeProvides["react-masonry-component"] = shadow$bridge("react-masonry-component");
module$shadow_js_shim_module$react_masonry_component.default = shadow.js.shim.module$react_masonry_component;
